<template>
    <div>
        <div id="content">
            <div class="menu-bar not-fixed">
                <span class="text">Başlangıç :</span>
                <input type="datetime-local" v-model="vdate" />
                <a class="btn btn-blue" @click.prevent="printVizitList()">
                    <i class="fa fa fa-print"></i> Yazdır
                </a>
            </div>
            <div class="birth-list">
                <div id="printVizitList">
                    <table>
                        <div v-if="!vizit.length" class="small-empty">
                            <i class="fa fa-info-circle fa-3x"></i>
                            <span>Kayıtlı Doğum Yok</span>
                        </div>
                        <thead>
                            <tr>
                                <th colspan="11" class="p-header">
                                    <h3>
                                        KADIN DOĞUM SERVİSİ BEBEK İZLEM FORMU
                                    </h3>
                                    <h3>
                                        {{ new Date() | moment("DD.MM.YYYY") }}
                                    </h3>
                                </th>
                            </tr>

                            <tr v-if="vizit.length">
                                <th class="c-center">Doğum Tarihi</th>
                                <th>Bebek Adı Soyadı</th>
                                <th>Anne Adı Soyadı</th>
                                <th class="c-center">Anne Kan Grubu</th>
                                <th>Bebek Kan Gr. D.Coombs</th>
                                <th class="c-center">Doğum Özellikleri</th>
                                <th class="c-center">Bebek Özellikleri</th>
                                <th class="c-center">Anne ELISA</th>
                                <th class="c-center">Takip</th>
                                <th class="c-center" colspan="2">Muayene</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="t in vizit" :key="t.id">
                                <td class="w-8 c-center">
                                    <b>{{
                                        t.birthdate | moment("DD.MM.YYYY")
                                    }}</b>
                                    <br />
                                    <span class="saat">{{
                                        inhours(t.birth) != 0
                                            ? inhours(t.birth) + ". saatinde"
                                            : ""
                                    }}</span>
                                </td>
                                <td class="w-12">{{ t.bebek }}</td>
                                <td class="w-12">{{ t.anne }}</td>
                                <td class="w-8 c-center">
                                    {{ t.annekan }}
                                </td>
                                <td class="w-12" :class="coombs(t)">
                                    {{ t.kan }}
                                    <br />
                                    {{ t.coombs }}
                                </td>
                                <td class="w-8 c-center">
                                    {{ t.sekil }}
                                    <br />
                                    {{ t.apgar }}
                                    <br />
                                    {{ t.birth | moment("HH:mm") }}
                                </td>
                                <td class="w-8 c-center">
                                    {{ t.week > 0 ? t.week + "w" : ""
                                    }}{{ t.day > 0 ? "+" + t.day + "d" : "" }}
                                    <br />
                                    {{ t.tarti > 0 ? t.tarti + " gr" : "" }}
                                    <br />
                                    {{ t.sex | toSex }}
                                </td>
                                <td class="w-8 c-center">{{ t.elisa }}</td>
                                <td class="w-8 c-top">
                                    <span class="detail">TCB :</span>
                                </td>
                                <td class="w-8">
                                    <span class="detail">Gaita</span>
                                    <span class="detail">İdrar</span>
                                    <span class="detail">Emme</span>
                                </td>
                                <td class="w-12">
                                    <span class="detail">Moro</span>
                                    <span class="detail">Yakalama</span>
                                    <span class="detail">KR:...../.....</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
export default {
    name: "Birthlist",
    data() {
        return {
            vdate: null,
            vizit: [],
        };
    },
    watch: {
        vdate: {
            deep: true,
            immediate: false,
            handler: function () {
                this.getVizit();
            },
        },
    },
    computed: {},
    methods: {
        //Vizit Listesi
        coombs(b) {
            if (b.coombs != "" && b.coombs != "D.Coombs (-)") {
                return "c-red";
            } else {
                return "";
            }
        },
        inhours(b) {
            var bd = this.$moment(b);
            var nd = this.$moment(new Date());
            return nd.diff(bd, "hours");
        },
        printVizitList() {
            const options = {
                name: "_blank",
                specs: [
                    "height=800",
                    "height=800",
                    "titlebar=yes",
                    "scrollbars=yes",
                ],
                styles: ["https://pediatrim.net/print/birthlist.css"],
            };
            this.$htmlToPaper("printVizitList", options);
        },
        getVizit() {
            let self = this;
            this.$http({
                method: "post",
                url: "api/yenidogan/births.php",
                data: qs.stringify({
                    q: "vizit",
                    bdate: this.$moment(this.vdate).format("YYYY-MM-DD HH:mm"),
                }),
            }).then(function (response) {
                self.vizit = response.data.data.birthlist;
                var l = response.data.data.birthlist.length;
                var i;
                var t;

                if (l < 12) {
                    t = 12 - l;
                }
                if (l > 12) {
                    t = 24 - l;
                }

                for (i = 0; i < t; i++) {
                    self.vizit.push({});
                }
            });
        },
    },
    created() {
        var n = this.$moment(new Date());
        this.vdate = this.$moment(
            n.add(-1, "days").format("YYYY-MM-DD") + "T00:00"
        ).format("YYYY-MM-DDTHH:mm");
    },
};
</script>

<style lang="scss">
</style>